(ns frontend.ui.component.lp-portal.report.body.innovestor.fund.pdf.pages.fund-overview
  (:require
   [common.util :as cu]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
   [frontend.ui.component.lp-portal.voima-components.pdf.column.view :as column]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :refer [card]]
   [frontend.ui.component.lp-portal.report.component.block-table.pdf-view :as block-table-pdf]))

(defn image
  [data]
  (when-not (cu/blank-value? (:image data))
    (card/card
     ""
     {:image (str (:image data))
      :width 200}
     (text-content/optional-footer data))))

(defn fund-overview-page
  [data]
  (let [{:keys [fund-overview executive-summary]} data]
    (page/page
     (page/page-title-with-line {:fund-name (:fund-name data)
                                 :page-title "Overview"
                                 :toc-item true
                                 :reporting-period (:reporting-period data)})
     (column/half-columns
      (card
       nil
       (block-table-pdf/table (:fund-overview-1 fund-overview) {:font-size 5})
       (text-content/rich-content (->> fund-overview
                                       :case-overview
                                       :rich-content)))
      (card
       ""
       (block-table-pdf/table (:fund-overview-2 fund-overview) {:font-size 5})
       (image (->> fund-overview
                   :fund-overview-image)))))))
